export interface IFormatedServiceBudget extends IDefaultServiceOption {
  discount?: number;
  appliedDiscount?: string;
  finalPrice: string;
  isPromotional: boolean;
  isOnRequest: boolean;
}

export interface IBudget {
  price?: number;
  applicableDiscount?: number;
  total?: number;
}

export interface IServicesFromBudget {
  budget: IBudget,
  items: IFormatedServiceBudget[];
}

export interface IRevisionFromBudget {
  budget: IBudget,
}

export interface IRemoteExperienceFromBudget {
  budget: IBudget;
}

export interface IDefaultServiceOption {
  id?: number;
  description?: string;
  serviceName: string;
  price: number;
  priceWithoutTax?: string;
  formattedPrice: string;
  isCostless: boolean;
  isSelected: boolean;
  isNeedComment: boolean;
}

export interface IFinalBudget {
  revision?: IRevisionFromBudget,
  services?: IServicesFromBudget;
  remoteExperience?: IRemoteExperienceFromBudget;
  budget: IBudget;
}
